import { paths, useCreateExpenseRequestQry } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'
import { useContext } from 'react'
import toast from 'react-hot-toast'
import { useHistory } from 'react-router-dom'
import './CreateExpenseRequestModal.scss'

interface Props {
  formValues: any
}

function CreateExpenseRequestModal({ formValues }: Props) {
  const { modalHide } = useContext(GlobalContext)

  const { description, setDescription, submitExpenseRequest, expenseRequestsError, expenseRequestsLoading } =
    useCreateExpenseRequestQry(formValues)

  const history = useHistory()

  function onSuccess() {
    modalHide()
    toast.success(tr('PORTAL.EXPENSE_REQUESTS.CREATE.SUCCESS_MESSAGE', 'Request successfully created'))
    history.push(paths.banking.expenses())
  }

  return (
    <div className='expense-request-modal'>
      <h3>{tr('PORTAL.EXPENSE_REQUESTS.CREATE.TITLE', 'You have reached your monthly limit')}</h3>

      <p>
        {tr(
          'PORTAL.EXPENSE_REQUESTS.CREATE.MESSAGE',
          'You can submit an expense request and after approval is received the transaction will be automatically initiated.'
        )}
      </p>

      <Input
        type='textarea'
        name='description'
        className='description-input'
        label={tr('PORTAL.EXPENSE_REQUESTS.CREATE.DESCRIPTION', 'Description')}
        value={description}
        onChange={(_: string, value: string) => setDescription(value)}
        rows={5}
      />

      <ErrorDisplay error={expenseRequestsError} />

      <Button
        color='primary'
        text={tr('PORTAL.EXPENSE_REQUESTS.CREATE.SUBMIT_BUTTON', 'Request')}
        onClick={() => submitExpenseRequest(onSuccess)}
        loading={expenseRequestsLoading}
      />
      <Button
        color='secondary'
        text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
        onClick={modalHide}
        disabled={expenseRequestsLoading}
      />
    </div>
  )
}

export default CreateExpenseRequestModal
